const Session = {

    // FIELDS
    "session_start": "Session Start",
    "session_end": "Session End",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "session": "Session",

    // ERROR
    "error_start": "Enter Session Start",
    "error_end": "Enter Session End",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_start": "SESSION START",
    "table_end": "SESSION END",
    "table_status": "STATUS",

}

export default Session;
